import React from 'react';

const InvalidIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 50 50">
        <path d="M30.5,25L48.89,6.52C50.4,5,50.37,2.56,48.8,1.08c-1.56-1.48-4.06-1.44-5.58,0.08L25,19.48L6.78,1.17C5.26-0.35,2.76-0.39,1.2,1.08C-0.37,2.56-0.4,5,1.11,6.52L19.5,25L1.11,43.48C-0.4,45-0.37,47.44,1.2,48.92C1.96,49.64,2.95,50,3.95,50c1.03,0,2.06-0.39,2.83-1.17L25,30.52l18.22,18.31c0.77,0.78,1.8,1.17,2.83,1.17c0.99,0,1.98-0.36,2.75-1.08c1.56-1.48,1.6-3.91,0.08-5.44L30.5,25z" />
    </svg>
);

export default InvalidIcon;
